export const adsBlockList = [
  'https://www.ifa.com.au/',
  'https://www.investordaily.com.au/',
  'https://www.nestegg.com.au/'
]


// WEBPACK FOOTER //
// ./src/constants/ads-block.js